module.exports = __webpack_public_path__ + "img/pre1-celular.8d9e85b0.jpg";